export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      FunctionInfo: {
        FunctionId: 5,
        FunctionName: 'ビデオチャット機能',
        DeliveryType: ''
      }
    }
  }
}